if (!customElements.get("product-tabs")) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();
      this.id = this.getAttribute("id");

      if (Shopify.designMode) {
        window.addEventListener(
          "shopify:section:load",
          this.init.bind(this)
        );
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.hideEmptyTabs();

      this.querySelectorAll(".product__tab--trigger").forEach(
        tabTrigger => {
          tabTrigger.addEventListener("click", evt => {
            this.openTab(
              evt,
              tabTrigger.dataset.tab
            );
          });
        }
      );

      this.openDefaultTab();
    }

    hideEmptyTabs() {
      this.querySelectorAll(".product__tab--trigger").forEach(trigger => {
        const tabName = trigger.dataset.tab;
        const content = this.querySelector(`#${tabName}`);

        if (!content) {
          trigger.style.display = "none";
          return;
        }

        const text = content.innerText?.trim();
        const hasImages = content.querySelector("img") !== null;
        const isEmpty = !text && !hasImages;

        if (isEmpty) {
          trigger.style.display = "none";
          content.style.display = "none";
        }
      });
    }

    openDefaultTab() {
      const event = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true
      });

      // Find the first visible default tab, or fall back to the first visible tab
      const defaultTrigger = this.querySelector(
        ".product__tab[data-default-open]:not([style*='display: none'])"
      );

      if (defaultTrigger) {
        defaultTrigger.dispatchEvent(event);
      } else {
        this.querySelector(
          ".product__tab--trigger:not([style*='display: none'])"
        )?.dispatchEvent(event);
      }
    }

    openTab(evt, tabName) {
      const tabcontents = this.querySelectorAll(
        ".product__tab-content"
      );
      tabcontents.forEach(content => {
        content.style.display = "none";
      });

      const tablinks = this.querySelectorAll(".product__tab");
      tablinks.forEach(link => {
        link.classList.remove("active");
      });

      const currentTabContent = this.querySelector(`#${tabName}`);

      if (currentTabContent) {
        currentTabContent.style.display = "block";
        if (evt.currentTarget) {
          evt.currentTarget.classList.add("active");
        }
      }
    }
  }
  customElements.define("product-tabs", ProductTabs);
}